module.exports = __webpack_public_path__ + "static/media/DeleteStock.32e353f8.svg";